var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let SelectNodeInput = class SelectNodeInput extends LitElement {
    onInputChange(event) {
        const selectElement = event.target;
        // Met à jour la propriété input avec la nouvelle valeur
        this.input.value = selectElement.value;
        // Déclenche l'événement personnalisé avec la nouvelle valeur de input
        this.dispatchEvent(new CustomEvent('node-input-change', {
            detail: { key: this.key, input: this.input },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        return html `
        <select-input
            .options=${this.input?.options || []}
            .value=${this.input?.value || ''}
            @select-change=${this.onInputChange}
        ></select-input>
    `;
    }
};
SelectNodeInput.styles = css `
      .select-node-input {
        width: 100%;
        padding: 6px 9px; /* Réduction de 25% */
        font-size: 10.5px; /* Réduction de 25% */
        border: 1px solid #ccc;
        border-radius: 3px; /* Réduction de 25% */
        box-sizing: border-box;
        transition: border-color 0.3s ease, box-shadow 0.3s ease;
        background-color: #fff;
        font-family: inherit;
      }

      .select-node-input:focus {
        border-color: #555ab9;
        box-shadow: 0 0 3px rgba(85, 90, 185, 0.5); /* Réduction de 25% */
        outline: none;
      }
    `;
__decorate([
    property({ type: String })
], SelectNodeInput.prototype, "key", void 0);
__decorate([
    property({ type: Object })
], SelectNodeInput.prototype, "input", void 0);
SelectNodeInput = __decorate([
    customElement('select-node-input')
], SelectNodeInput);
export { SelectNodeInput };
//# sourceMappingURL=SelectNodeInput.js.map